"use client";

import DataFetchingSpinner from "@/components/layouts/components/spinners/DataFetchingSpinner";
import { useAxios } from "@/lib/http/axios-client";
import { useAuth } from "@/providers/auth.provider";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function InvitationCodeRedirect({
  params,
}: {
  params: Promise<{ code: string }>;
}) {
  const router = useRouter();
  const [code, setCode] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const { login } = useAuth() as any;
  const axiosClient = useAxios();

  useEffect(() => {
    const resolveParams = async () => {
      const resolvedParams = await params;
      setCode(resolvedParams.code);
    };

    resolveParams();
  }, [params]);

  useEffect(() => {
    if (code) {
      authenticateDemoUser();
    }
  }, [code]);

  const authenticateDemoUser = async () => {
    try {
      const response = await axiosClient.post(
        `/auth/demo-authenticate/${code}`,
      );

      const authRes = response.data.data;

      await login(authRes);

      router.push("/onboarding");
    } catch (err: any) {
      console.error("Demo authentication failed:", err);

      const errorMessage =
        err?.response?.data?.message || "Authentication failed";

      if (
        errorMessage.includes("not for a demo group") ||
        errorMessage.includes("Invalid invitation code")
      ) {
        sessionStorage.setItem("invitation_redirect", "true");
        router.replace(`/login?invitation_code=${code}`);
      } else {
        setError(errorMessage);
      }
    }
  };

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen">
        <p className="text-red-500">{error}</p>
        <button
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
          onClick={() => router.push("/login")}
        >
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <DataFetchingSpinner />
      <p className="mt-4 text-yellow-900 dark:text-yellow-300">
        Redirecting...
      </p>
    </div>
  );
}
